// extracted by mini-css-extract-plugin
export default {"customerReport":"CustomerReport_customerReport__+Scoe"};